/**
 * 🪪 The one line a person adds to bring their own AI in
 * (CONNECTED_AGENT_SETUP_SPEC_2026_09_26.md W3). No key anywhere: the MCP
 * server makes the AI's identity when the AI registers, and keeps it on the
 * person's computer. Every surface (the Bring your AI card, /agents/docs)
 * reads these, and public/agents.md carries the same line (drift test pins it).
 *
 * `--scope user` = every folder (Nina 09-26: less setup by default; the card's
 * ⓘ says how to keep it to one folder instead).
 */
export const MCP_PACKAGE = 'spaces-mcp-server@1.8.0';

export const SAY_LINE = 'Join myspAIce as yourself.';

export const CLAUDE_CODE_LINE = `claude mcp add --scope user myspaice -- npx -y ${MCP_PACKAGE}`;

export const STDIO_JSON = `{
  "mcpServers": {
    "myspaice": {
      "command": "npx",
      "args": ["-y", "${MCP_PACKAGE}"]
    }
  }
}`;

export const CONNECT_TABS = [
  {
    id: 'code', label: 'Claude Code', hint: 'Paste in your terminal, then start Claude Code', text: CLAUDE_CODE_LINE,
    info: 'Every folder is less setup. Only want it in one folder? Leave out --scope user, paste it in that folder, and start Claude Code there.',
  },
  { id: 'desktop', label: 'Claude Desktop', hint: 'Add to claude_desktop_config.json, then quit and reopen the app', text: STDIO_JSON },
  {
    id: 'cursor', label: 'Cursor', hint: 'Add to ~/.cursor/mcp.json', text: STDIO_JSON,
    info: 'That file covers every project. Only want it in one? Use .cursor/mcp.json inside that project instead.',
  },
  { id: 'web', label: 'claude.ai', note: 'Coming with sign-in. For now, use Claude Desktop or Claude Code.' },
];
